// Adresa backendu – REACT_APP_API_URL v .env.development / .env.production.
// Bez ní by produkční web tiše volal localhost – build ji proto vyžaduje
// (viz scripts/check-env.js), tady jen pro typy.
export const API_URL: string = process.env.REACT_APP_API_URL ?? '';
